export const INTERNAL_ROLE_LABELS = {
  OWNER: "Dirigeant",
  SALES: "Commercial",
  ASSISTANT: "Secrétaire / Assistante",
  SITE_MANAGER: "Chantier",
  CUSTOM: "Personnalisé",
};

export const canUse = (membership, permission) => membership?.internal_role === "OWNER"
  || membership?.permissions?.includes("*")
  || membership?.permissions?.includes(permission);

export const canUseAny = (membership, permissions = []) => permissions.some((permission) => canUse(membership, permission));